import { ApiCall } from '../ApiClient';
import { ResultData, WorkspaceFolderData, WorkspaceFolderLiteData } from '../ApiTypes';
import { dateTransformer } from '../ApiUtil';

const get = <TResponse>(def: Omit<ApiCall<never, TResponse>, 'method'>): ApiCall<never, TResponse> =>
    Object.assign(def, { method: 'get' });

const post = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'post' });

const put = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'put' });

const info = (folderId: string) => get<WorkspaceFolderData>({
    path: '/folders.info',
    query: { folderId },
    transform: dateTransformer(),
});

type CreateBody = { workspaceId: string, label: string };
const create = (body: CreateBody) => post<WorkspaceFolderLiteData>({
    path: '/folders.create', body
});

type UpdateBody = { folderId: string, label?: string };
const update = (body: UpdateBody) => post<WorkspaceFolderLiteData>({
    path: '/folders.update', body
});

type DeleteBody = { folderId: string };
const de1ete = (body: DeleteBody) => post<ResultData>({
    path: '/folders.delete', body
});

export const foldersEndpoints = {
    info,
    create,
    de1ete,
    update,
};
